import NProgress from 'nprogress';

const useRequestProgress = (request) => [
  async (...args) => {
    NProgress.start();
    await request(...args);
    NProgress.done();
  },
];

export default useRequestProgress;
